import GatewayBase from './gateway-base';
import { FilterType } from '@constants';
import type { FilterConfig } from '@monolog/shared/types';

export default class FiltersRestService extends GatewayBase {
  get filters() {
    return {
      ofType: this.getFilters,
    };
  }

  private getFilters = (type: FilterType) => {
    let url = '';
    switch (type) {
      // STORE CREDIT
      case FilterType.storeCredit: {
        url = '/v1/claims/filters/ClaimStoreCredit';
        break;
      }
      // CLAIM
      case FilterType.claim: {
        url = '/v1/claims/filters/Claim';
        break;
      }
      // ORDER
      case FilterType.order: {
        url = '/v1/orders/filters/Order';
        break;
      }
      // PAYOUT
      case FilterType.payout: {
        url = '/v1/billing/payouts/filters/Payout';
        break;
      }
      // RETURN
      case FilterType.return: {
        url = '/v1/returns/filters';
        break;
      }
      // PRODUCT
      case FilterType.product: {
        url = '/v1/orders/filters/Product';
        break;
      }
      // WARRANTY
      case FilterType.warranty: {
        url = '/v1/claims/filters/Warranty';
        break;
      }
      // GALLERY
      case FilterType.gallery: {
        url = '/v1/claims/filters/Gallery';
        break;
      }
      // CLAIM AUTOMATION
      case FilterType.claimAutomation: {
        url = '/v1/claims/automation/filters';
        break;
      }
      // CLAIM AUTOMATION STORES
      case FilterType.claimAutomationStores: {
        url = '/v1/claims/automation/store-stats/filters';
        break;
      }
      // CLAIM AUTOMATION MODELS
      case FilterType.claimAutomationModels: {
        url = '/v1/claims/automation/model-stats/filters';
        break;
      }
      // CLAIM AUTOMATION SENTIMENT
      case FilterType.claimAutomationSentiment: {
        url = '/v1/claims/automation/sentiment/filters';
        break;
      }
      // CLAIM AUTOMATION CONTROL PANEL
      case FilterType.claimAutomationControlPanel: {
        url = '/v1/claims/automation/admin/control-panel/filters';
        break;
      }
      // CLAIM AUTOMATION AI SPEND
      case FilterType.claimAutomationAiSpendFeatures: {
        url = '/v1/claims/automation/ai-spend/filters/features';
        break;
      }
      case FilterType.claimAutomationAiSpendModels: {
        url = '/v1/claims/automation/ai-spend/filters/models';
        break;
      }
      case FilterType.claimAutomationAiSpendStores: {
        url = '/v1/claims/automation/ai-spend/filters/stores';
        break;
      }
      // REVIEWS
      case FilterType.reviews: {
        url = '/v1/claims/reviews/filters';
        break;
      }
      default:
        throw new Error(`Unsupported filter type: ${type}`);
    }

    return this.client.get<FilterConfig[]>(url);
  };
}
